import { createAndFireEvent, type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { AnalyticsPayload } from '../types';
import { ANALYTICS_CHANNEL } from './constants';

const createAndFireEventOnPeopleTeams = createAndFireEvent(ANALYTICS_CHANNEL);

/**
 * All Invite People analytics should go through this low level function.
 *
 * You can use it in test assertions.
 */
export const fireAnalyticsEvent = (
	payload: AnalyticsPayload,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
) => {
	const fire = createAndFireEventOnPeopleTeams(payload);

	fire(createAnalyticsEvent);
};

export type FireAnalyticsEvent = typeof fireAnalyticsEvent;
